define.alias("shared/components/shared/wizards/device-setup/step-one", "settings/components/shared/wizards/device-setup/step-one");